import { GroupByOption, StoredMetric } from "../common-tile.model";

export enum PieChartDisplayMode {
  SinglePie = 'SinglePie',
  SeparatePies = 'SeparatePies',
  MetricGroups = 'MetricGroups'
}

export class PieMetric {
  color: string;
  metric: StoredMetric;
  groupName?: string;

  constructor(color?: string, metric?: StoredMetric, groupName?: string) {
    this.color = color;
    this.metric = metric;
    this.groupName = groupName;
  }
}

export class StoredPieTileDefinition {
  header: string;
  useGroupBy: boolean;
  groupBy: GroupByOption;
  metrics: PieMetric[];
  displayMode: PieChartDisplayMode;

  constructor(
    header: string,
    useGroupBy: boolean = true,
    groupBy: GroupByOption,
    metrics: PieMetric[] = [],
    displayMode: PieChartDisplayMode = PieChartDisplayMode.SinglePie
  ) {
    this.header = header;
    this.useGroupBy = useGroupBy;
    this.groupBy = groupBy;
    this.metrics = metrics;
    this.displayMode = displayMode;
  }
}